module.exports = __webpack_public_path__ + "media/dashboard/assets/images/mobile-app-phone-5944f0622874272935d217c457962f87.png";